import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Save, Loader2, MapPin } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { money } from "@/lib/format";

// Enhancer's own price at each center for a center service; blank = the center's price.
export const ApprovalLocationPrices = ({ approval }) => {
  const qc = useQueryClient();
  const rows = approval.price_locations || [];
  const [vals, setVals] = useState(() => Object.fromEntries(rows.map((r) => [r.location_id, r.my_price ?? ""])));
  const [saving, setSaving] = useState(false);
  if (!approval.approved || rows.length === 0) return null;
  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/enhancer/me/center-approvals/${approval.id}/location-prices`, { prices: vals });
      toast.success("Your prices are saved");
      qc.invalidateQueries({ queryKey: ["my-center-approvals"] });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div className="mt-4 pt-3 border-t border-[#E5E0D8]" data-testid={`approval-prices-${approval.id}`}>
      <p className="text-xs font-semibold text-[#4A5D6B] uppercase tracking-wide mb-2 flex items-center gap-1.5"><MapPin size={12} /> Your price at each location</p>
      <div className="space-y-2">
        {rows.map((r) => (
          <label key={r.location_id} className="flex items-center gap-3 text-sm">
            <span className="flex-1 min-w-0 truncate text-[#2A3942]">{r.name}</span>
            <span className="text-xs text-[#8FA89B] shrink-0">Center {money(Number(r.center_price || 0))}</span>
            <input type="number" min="0" step="1" value={vals[r.location_id] ?? ""} placeholder="Same"
              onChange={(e) => setVals({ ...vals, [r.location_id]: e.target.value })}
              data-testid={`approval-price-${approval.id}-${r.location_id}`} className="eyw-input !py-1.5 w-24 text-sm" />
          </label>
        ))}
      </div>
      <p className="text-[11px] text-[#8FA89B] mt-1.5">Only applies when members book with you. Leave blank to use the center's price.</p>
      <button onClick={save} disabled={saving} data-testid={`approval-prices-save-${approval.id}`} className="eyw-btn-ghost !py-1.5 !px-3 text-xs mt-2">
        {saving ? <Loader2 className="animate-spin" size={13} /> : <Save size={13} />} Save prices
      </button>
    </div>
  );
};
